<template>
  <div>
    <queryFrame @handlePage='handlePage' @handlePageSize='handlePageSize'
      :count="count" :current="page">
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>销售订单:</label>
            <lk-input :maxlength='100' placeholder='请输入销售订单号' class="item" clearable
              v-model.trim='query.orderCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>商品:</label>
            <lk-input :maxlength='100' placeholder='请输入商品编码/商品名/通用名' class="item" clearable
              v-model.trim='query.nameMix'></lk-input>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label >门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>创建日期:</label>
            <timeStampDatePicker  type='daterange'  placeholder="请选择"   class="item" v-model.trim='query.createTime' ></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>医院名称:</label>
            <lk-input placeholder='请输入医院名称' class="item" clearable
              v-model.trim='query.hospital'></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <DownloadButton v-if="handlePermission('OTCRecordFlowExcel')"  @on-click="handleExport"></DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData' >
        </lk-table>
      </div>
    </queryFrame>
  </div>
</template>
<script>
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import dataDirect from '../../services/dataDirect';
import utils from '../../libs/utils';
import queryFrame from '../../components/frame/QueryFrame.vue';
import DownloadButton from '../../components/download/DownloadButton';


export default {
  name: 'dataUploadList',
  components: {
    queryFrame,
    DownloadButton,
  },
  mixins: [mapState, queryMixins],
  data() {
    return {
      query: {},
      tableData: [],
      columns: [
        {
          title: '序号',
          width: 60,
          render: (h, params) => h('span', params.index + (this.page - 1) * this.size + 1),
        },
        {
          title: '销售订单号',
          key: 'orderCode',
          minWidth: 116,
        },
        {
          title: '创建时间',
          minWidth: 116,
          key: 'createTime',
        }, {
          title: '完成时间',
          minWidth: 116,
          key: 'finishTime',
        },
        {
          title: '商品编码',
          key: 'serialCode',
          minWidth: 116,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 116,
        },
        {
          title: '通用名称',
          key: 'approvedName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'spec',
          minWidth: 116,
        },
        {
          title: '批准文号',
          key: 'approvalCode',
          minWidth: 116,
        }, {
          title: '生产企业',
          key: 'producer',
          minWidth: 116,
        }, {
          title: '批次号',
          key: 'batchSeq',
          minWidth: 116,
        }, {
          title: '医院名称',
          key: 'hospital',
          minWidth: 116,
        }, {
          title: '患者姓名',
          key: 'patientName',
          minWidth: 116,
        },
        {
          title: '联系方式',
          key: 'patientPhone',
          minWidth: 116,
        },
      ],
    };
  },
  methods: {
    getData() {
      this.tableData = [];
      this.params.size = this.size;
      this.params.page = this.page;
      const params = utils.deepClone(this.params);
      if (this.params.createTime && this.params.createTime.length === 2) {
        params.createTimeStart = this.params.createTime[0];
        params.createTimeEnd = this.params.createTime[1];
        delete params.createTime;
      }
      dataDirect.getSalePrescriptionOTCList(params).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.count = data.count;
          data.list.forEach((item) => {
            item.createTime = utils.exchangeTime(item.createTime);
            item.finishTime = utils.exchangeTime(item.finishTime);
            const pat = /(\d{3})\d*(\d{4})/;
            item.patientPhone = item.patientPhone.replace(pat, '$1****$2');
            this.tableData.push(item);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        createTime: [],
      };
    },
    handleExport() {
      const params = utils.deepClone(this.params);
      delete params.page;
      delete params.size;
      if (this.params.createTime && this.params.createTime.length === 2) {
        params.createTimeStart = this.params.createTime[0];
        params.createTimeEnd = this.params.createTime[1];
        delete params.createTime;
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      dataDirect.downloadSalePrescriptionOTC(params).then((res) => {
        if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
.btns{
  margin-bottom: 16px;
  >*{
    margin-right: 8px
  }
}
</style>
